
<div id="custom-overlay">
    <div class="flb">
        <!-- <div class="Aligner-item Aligner-item--top"></div> -->
      <img src="assets/images/recycle.png" style="width: 100px; height: auto;">
      <!-- <div class="Aligner-item Aligner-item--bottom"></div> -->
    </div>
  </div>
